import React, { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { logoLight } from "../../../assets/images";
import axios from "axios";

const SignUp = () => {
  // ============= Initial State Start here =============
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [password_confirmation, setPassword_Confirmation] = useState("");

  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  // ============= Initial State End here ===============
  // ============= Error Msg Start here =================
  const [errName, setErrName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errContact, setErrContact] = useState("");
  const [errAddress, setErrAddress] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [errPassword_Confirmation, setErrPassword_Confirmation] = useState("");
  // const [err, setErrPassword] = useState("");
  // ============= Error Msg End here ===================
  const [successMsg, setSuccessMsg] = useState("");
  // ============= Event Handler Start here =============
  const handleName = (e) => {
    setName(e.target.value);
    setErrName("");
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };
  const handleContact = (e) => {
    setContact(e.target.value);
    setErrContact("");
  };
  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };
  const handleConfirmPassword = (e) => {
    setPassword_Confirmation(e.target.value);
    setErrPassword_Confirmation("");
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
    setErrAddress("");
  };
  // ============= Event Handler End here ===============
  // ================= Email Validation start here =============
  const EmailValidation = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
  };
  // ================= Email Validation End here ===============

  // ... (sebelumnya didefinisikan)

  const handleSignUp = async (e) => {
    e.preventDefault();
    console.log("BEFORE CONSUME API");

    // Error messages for form fields
    let errors = {
      errClientName: "",
      errEmail: "",
      errPhone: "",
      errAddress: "",
      errPassword: "",
      errPassword_Confirmation: "",
    };

    if (checked) {
      if (!name) {
        errors.errClientName = "Enter your name";
      }
      if (!email) {
        errors.errEmail = "Enter your email";
      } else {
        if (!EmailValidation(email)) {
          errors.errEmail = "Enter a Valid email";
        }
      }
      if (!contact) {
        errors.errPhone = "Enter your phone number";
      }
      if (!password) {
        errors.errPassword = "Create a password";
      } else {
        if (password.length < 6) {
          errors.errPassword = "Passwords must be at least 6 characters";
        }
      }
      if (password !== password_confirmation) {
        errors.errPassword_Confirmation = "Passwords do not match";
        setErrPassword_Confirmation(errors.errPassword_Confirmation);
      }
      if (!address) {
        errors.errAddress = "Enter your address";
      }
    }
    console.log(name, email);
    // Update error messages
    setErrName(errors.errname);
    setErrEmail(errors.errEmail);
    setErrContact(errors.errContact);
    setErrPassword(errors.errPassword);
    setErrPassword_Confirmation(errors.errPassword_Confirmation);
    setErrAddress(errors.errAddress);
    console.log(errors.errAddress);
    try {
      if (
        checked &&
        name &&
        email &&
        EmailValidation(email) &&
        contact &&
        password &&
        password_confirmation &&
        address &&
        password.length >= 6 &&
        !errors.errName &&
        !errors.errEmail &&
        !errors.errContact &&
        !errors.errPassword &&
        !errors.errPassword_Confirmation &&
        !errors.errAddress
      ) {
        const data = {
          name: name,
          contact: contact,
          email: email,
          address: address,
          password: password,
          password_confirmation: password_confirmation,
        };
        console.log("DATA SENT", data);

        try {
          const response = await axios.post(
            "https://erp.digitalindustryagency.com/api/register",
            data
          );
          setSuccessMsg(
            `Hello dear ${name}, Welcome to OREBI Admin panel. We received your Sign up request. We are processing to validate your access. Till then stay connected and additional assistance will be sent to you by your mail at ${email}`
          );
          setName("");
          setEmail("");
          setContact("");
          setPassword("");
          setPassword_Confirmation("");
          setAddress("");
          alert("Sign up Successful!");
          navigate("/signin");
          console.log("Berhasil : ", response);
        } catch (error) {
          console.error("Error during axios.post:", error);
          // Handle error (mungkin menetapkan pesan kesalahan atau memberi tahu pengguna)
        }
      }
    } catch (error) {
      console.error("Error in try block:", error);
    }

    // try {
    //   if (
    //     checked &&
    //     name &
    //     email &&
    //     EmailValidation(email) &&
    //     password &&
    //     password_confimation &&
    //     address &&
    //     password.length >= 6 &&
    //     !errors.errname &&
    //     !errors.errEmail &&
    //     !errors.errPhone &&
    //     !errors.errPassword &&
    //     !errors.errPassword_Confirmation &&
    //     !errors.errAddress
    //   ) {
    //     const data = {
    //       name: name,
    //       contact: contact,
    //       email: email,
    //       address: address,
    //       password: password,
    //       confirmPassword: password_confimation,
    //       // You might need to adjust field names to match your API requirements
    //     };
    //     console.log("DATA SENT", data)
    //     axios.post("https://erp.digitalindustryagency.com/api/register", data)
    //       .then((response) => {
    //         setSuccessMsg(
    //           `Hello dear ${name}, Welcome you to OREBI Admin panel. We received your Sign up request. We are processing to validate your access. Till then stay connected and additional assistance will be sent to you by your mail at ${email}`
    //         );
    //         setName("");
    //         setEmail("");
    //         setContact("");
    //         setPassword("");
    //         setPassword_Confirmation(""); // Clear confirmPassword field
    //         setAddress("");
    //         alert("Sign up Successful!");
    //         navigate("/signin");
    //         console.log("Berhasil : ", response);
    //         // localStorage.setItem('notification', JSON.stringify(notification));
    //         navigate('/signin');
    //       });
    //     // Handling successful API response
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    // }
  };
  return (
    <div className="w-full h-screen flex items-center justify-start">
      <div className="w-1/2 hidden lgl:inline-flex h-full text-white">
        <div className="w-[450px] h-full bg-primeColor px-10 flex flex-col justify-center">
          <div>
            <Link to="/">
              <img src={logoLight} alt="logoImg" className="w-28 flex" />
            </Link>
          </div>
          <div className="flex flex-col mt-2">
            <h1 className="font-titleFont text-xl font-medium">
              Stay sign in for more
            </h1>
            <p className="text-base">When you sign in, you are with us!</p>
          </div>
          <div className="w-[300px] flex items-start gap-3">
            <span className="text-green-500 mt-1">
              <BsCheckCircleFill />
            </span>
            <p className="text-base text-gray-300">
              <span className="text-white font-semibold font-titleFont">
                Get started fast with SINAR KENCANA
              </span>
              <br />
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab omnis
              nisi dolor recusandae consectetur!
            </p>
          </div>
          <div className="w-[300px] flex items-start gap-3">
            <span className="text-green-500 mt-1">
              <BsCheckCircleFill />
            </span>
            <p className="text-base text-gray-300">
              <span className="text-white font-semibold font-titleFont">
                Access all SINAR KENCANA services
              </span>
              <br />
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab omnis
              nisi dolor recusandae consectetur!
            </p>
          </div>
          <div className="w-[300px] flex items-start gap-3">
            <span className="text-green-500 mt-1">
              <BsCheckCircleFill />
            </span>
            <p className="text-base text-gray-300">
              <span className="text-white font-semibold font-titleFont">
                Trusted by online Shoppers
              </span>
              <br />
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab omnis
              nisi dolor recusandae consectetur!
            </p>
          </div>
          <div className="flex items-center justify-between mt-5">
            <Link to="/">
              <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
                © SINAR KENACANA
              </p>
            </Link>
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              Terms
            </p>
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              Privacy
            </p>
            <p className="text-sm font-titleFont font-semibold text-gray-300 hover:text-white cursor-pointer duration-300">
              Security
            </p>
          </div>
        </div>
      </div>
      <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
        {successMsg ? (
          <div className="w-[500px]">
            <p className="w-full px-4 py-10 text-green-500 font-medium font-titleFont">
              {successMsg}
            </p>
            <Link to="/signin">
              <button
                className="w-full h-10 bg-primeColor rounded-md text-gray-200 text-base font-titleFont font-semibold 
            tracking-wide hover:bg-black hover:text-white duration-300"
              >
                Sign in
              </button>
            </Link>
          </div>
        ) : (
          <form
            className="w-full lgl:w-[500px] h-screen flex items-center justify-center"
            onSubmit={handleSignUp}
          >
            <div className="px-6 py-4 w-full h-[96%] flex flex-col justify-start overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
              <h1 className="font-titleFont underline underline-offset-4 decoration-[1px] font-semibold text-2xl mdl:text-3xl mb-4">
                Create your account
              </h1>
              <div className="flex flex-col gap-3">
                {/* client name */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-gray-600">
                    Full Name
                  </p>
                  <input
                    onChange={handleName}
                    value={name}
                    className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                    type="text"
                    placeholder="eg. John Doe"
                  />
                  {errName && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errName}
                    </p>
                  )}
                </div>
                {/* Email */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-gray-600">
                    Email
                  </p>
                  <input
                    onChange={handleEmail}
                    value={email}
                    className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                    type="email"
                    placeholder="john@workemail.com"
                  />
                  {errEmail && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errEmail}
                    </p>
                  )}
                </div>
                {/* Phone Number */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-gray-600">
                    Phone Number
                  </p>
                  <input
                    onChange={handleContact}
                    value={contact}
                    className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                    type="text"
                    placeholder="008801234567891"
                  />
                  {errContact && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errContact}
                    </p>
                  )}
                </div>
                {/* Address */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-gray-600">
                    Address
                  </p>
                  <input
                    onChange={handleAddress}
                    value={address}
                    className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                    type="text"
                    placeholder="road-001, house-115, example area"
                  />
                  {errAddress && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errAddress}
                    </p>
                  )}
                </div>
                {/* Password */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-gray-600">
                    Password
                  </p>
                  <input
                    onChange={handlePassword}
                    value={password}
                    className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                    type="password"
                    placeholder="Create password"
                  />
                  {errPassword && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errPassword}
                    </p>
                  )}
                </div>
                {/* ConfirmPassword */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-gray-600">
                    Confirm Password
                  </p>
                  <input
                    onChange={handleConfirmPassword}
                    value={password_confirmation}
                    className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                    type="password"
                    placeholder="Create password"
                  />
                  {errPassword_Confirmation && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errPassword_Confirmation}
                    </p>
                  )}
                </div>
                {/* Checkbox */}
                <div className="flex items-start mdl:items-center gap-2">
                  <input
                    onChange={() => setChecked(!checked)}
                    className="w-4 h-4 mt-1 mdl:mt-0 cursor-pointer"
                    type="checkbox"
                  />
                  <p className="text-sm text-primeColor">
                    I agree to the SINAR KENCANA{" "}
                    <span className="text-blue-500">Terms of Service </span>and{" "}
                    <span className="text-blue-500">Privacy Policy</span>.
                  </p>
                </div>
                <button
                  type="submit"
                  onClick={handleSignUp}
                  className={`${
                    checked
                      ? "bg-primeColor hover:bg-black hover:text-white cursor-pointer"
                      : "bg-gray-500 hover:bg-gray-500 hover:text-gray-200 cursor-none"
                  } w-full text-gray-200 text-base font-medium h-10 rounded-md hover:text-white duration-300`}
                >
                  Create Account
                </button>
                <p className="text-sm text-center font-titleFont font-medium">
                  Don't have an Account?{" "}
                  <Link to="/signin">
                    <button
                      type="submit"
                      className="hover:text-blue-600 duration-300"
                    >
                      Sign in
                    </button>
                  </Link>
                </p>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SignUp;
